import React from "react";

import { faGavel } from "@fortawesome/pro-regular-svg-icons";
import { COLORS } from "rylak-common/src/constants";
import { CHIP_COLOR_TYPES, ChipTooltip, CustomChip } from "../CustomChip.jsx";

export function WithdrawalChip(props) {
    return (
        <CustomChip
            {...props}
            icon={faGavel}
            label={"Withdrawal"}
            colorType={CHIP_COLOR_TYPES.DONE}
            tooltipTitle={
                <ChipTooltip
                    title={
                        <div>
                            <span style={{ color: COLORS.WEAK_TEXT }}>Return Type - </span>
                            Withdrawal
                        </div>
                    }
                    content={"The customer registered this return under their statutory right of withdrawal."}
                />
            }
        />
    );
}
